import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../../utils/flexible.js';
export default {
  name: 'audioGuide',
  data() {
    return {
      isActive: 1,
      bannersList: [],
      //轮播图
      // canIUse: wx.canIUse('button.open-type.getUserInfo'),
      page: 1,
      limit: 50,
      exhibType: '',
      //展览类型
      exhibitions: [],
      //展览列表
      // imgUrl: app.globalData.imgUrl,
      inputValue: '',
      //关键词
      nextPage: true,
      //是否存在下一页数据
      museumList: [],
      //场馆列表
      singleform: {
        deptId: 190059,
        formId: 214493,
        page: 1,
        limit: 200
      },
      bannerForm: {
        deptId: 190059,
        formId: 171927,
        page: 1
      },
      swiperEl: ''
    };
  },
  methods: {
    search() {
      this.getMuseumList(this.inputValue);
    },
    showMuseumList(item) {
      this.$router.push(`/exhibitions?fid=${item.fid}`);
    },
    getBanner() {
      this.$api.singleadvanceSearch(this.bannerForm).then(res => {
        let list = this.setDatas(res.dataList, 'banner');
        this.bannersList = list;
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperNav, {
            slidesPerView: 'auto',
            centeredSlides: true,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            loop: true
          });
        });
      });
    },
    getMuseumList(search) {
      let data = this.singleform;
      if (search) {
        data.searchStr = {
          filters: [[{
            alias: 'name',
            compt: "editinput",
            express: 'like',
            id: 1,
            range: null,
            val: search
          }]],
          model: 0
        };
        data.searchStr = encodeURI(JSON.stringify(data.searchStr));
      }
      this.$api.singleadvanceSearch(data).then(res => {
        this.museumList = this.setDatas(res.dataList, 'list');
      });
    },
    setDatas(data, type) {
      return data.map(item => {
        let target = type == 'list' ? {
          shortName: this.getFormData(item, 'name', 'val'),
          audio_formId: 171925,
          banner_formId: 171927,
          exhibition_formId: 171924,
          imgPath: this.getFormData(item, 'image', 'fileUrl'),
          adLink: this.getFormData(item, 'address', 'val'),
          fid: this.getFormData(item, 'fid', 'val')
        } : {
          bannerImage: this.getFormData(item, 'image', 'fileUrl'),
          bannerName: this.getFormData(item, 'name', 'val')
        };
        return target;
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    }
  },
  created() {
    document.title = '语音导览';
    flexible();
    this.singleform = {
      deptId: this.$route.query.fid,
      formId: 214493,
      page: 1,
      limit: 200
    };
    this.bannerForm = {
      deptId: this.$route.query.fid,
      formId: 171927,
      page: 1
    };
    this.getBanner();
    this.getMuseumList();
  },
  computed: {}
};